/**
 *
 *  Organizations/Show/ContactSms
 *
 */

import React from 'react'

// NPM Libraries
import Toggle from 'react-toggle'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

// Graphql
import useQuery from 'components/UseQuery'
import { useMutation, gql } from '@apollo/client'

const GET_PREFERENCES = gql`
	query getSmsPreferences($id: ID!) {
		organization(id: $id) {
			id
			contact_sms
		}
		contact_sms_types
	}
`

const UPDATE_ORGANIZATION = gql`
	mutation updateOrganization($id: ID!, $contact_sms: JSON) {
		updateOrganization(input: { id: $id, contact_sms: $contact_sms }) {
			organization {
				id
				contact_sms
			}
		}
	}
`

function ContactSms({ organization_id }) {
	const {
		data: { organization, contact_sms_types },
	} = useQuery(GET_PREFERENCES, {
		variables: { id: organization_id },
	})

	const [mutate] = useMutation(UPDATE_ORGANIZATION)

	const updateContactSmsPreferences = (value, checked) => {
		mutate({
			variables: {
				id: organization_id,
				contact_sms: update(organization.contact_sms, {
					[value]: { $set: checked },
				}),
			},
		})
	}

	if (!contact_sms_types) return null

	return (
		<div className="container-fluid mt-3 pt-3">
			<div className="row">
				{Object.keys(contact_sms_types).map((category) => (
					<div className="col-md-6" key={category}>
						<div className="card">
							<div className="card-header">
								<h3 className="card-title">{category} SMS</h3>
							</div>

							<ul className="list-group list-group-flush">
								{contact_sms_types[category].map((sms_type) => (
									<li key={sms_type.value} className="list-group-item">
										{sms_type.title}
										<div className="float-right">
											<Toggle
												value={sms_type.value}
												checked={organization.contact_sms[sms_type.value]}
												onChange={(e) =>
													updateContactSmsPreferences(sms_type.value, e.target.checked)
												}
											/>
										</div>
									</li>
								))}
							</ul>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

ContactSms.propTypes = {
	organization_id: PropTypes.string,
}

export default ContactSms
